import { render, staticRenderFns } from "./EditorExtraStagePoints.vue?vue&type=template&id=7a96004f&scoped=true"
import script from "./EditorExtraStagePoints.vue?vue&type=script&lang=js"
export * from "./EditorExtraStagePoints.vue?vue&type=script&lang=js"
import style0 from "./EditorExtraStagePoints.vue?vue&type=style&index=0&id=7a96004f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a96004f",
  null
  
)

export default component.exports